import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import FileReducer, {
  defaultState,
  asyncActions,
  syncActions,
} from 'src/ducks/file.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FileReducer, defaultState, {
    ...asyncActions,
    ...syncActions,
  });
};

type IFileContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FileContext = createContext<Partial<IFileContext>>({
  state: defaultState,
}) as React.Context<IFileContext>;

const FileProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FileContext.Provider value={{ ...reducer }}>
      {children}
    </FileContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFileContext = () => useContext(FileContext);

export type IuseFileContext = ReturnType<typeof useFileContext>;

export { FileContext, FileProvider };
